import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import Exemption from "./view/Exemption";
import ExemptionList from "./components/ExemptionList";
import Auth from "../dashboard/modules/auth/middleware/Auth";
import ProfileComplete from "../dashboard/modules/auth/middleware/ProfileComplete";
import ExemptionCard from "./components/ExemptionCard";
import ExemptionPayments from "./components/ExemptionPayments";
import ExemptionLetter from "./components/ExemptionLetter";
import ExemptionReceipt from "./components/ExemptionReceipt";
import AcknoledgementLetter from "./components/AcknoledgementLetter";
const ExemptionsRoutes = [
  {
    path: "/exemptions",
    component: Dashboard,
    name: "Exemption",
    children: [
      {
        path: "",
        component: Exemption,
        meta: {
          title: "KISEB::Exemptions",
          page: "Exemptions",
        },
        children: [
          {
            path: "listing",
            name: "Exemptions",
            component: ExemptionList,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "card/:code?",
            name: "ExemptionCard",
            component: ExemptionCard,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "payments/:code?",
            name: "ExemptionPayments",
            component: ExemptionPayments,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "receipt/:code?",
            name: "ExemptionReceipt",
            component: ExemptionReceipt,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "exemption-letter/:code?",
            name: "ExemptionLetter",
            component: ExemptionLetter,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "acknowledgement-letter/:code?",
            name: "AcknoledgementLetter",
            component: AcknoledgementLetter,
            meta: { middleware: [Auth, ProfileComplete] },
          },
        ],
      },
    ],
  },
];

export default ExemptionsRoutes;
